<div class="panel-box" [ngBusy]="{busy: loading, message: ('common.pleaseWait' | translate)}">
  <div class="pb-header pb-header-with-btn mb-sm-max-3">
    <span class="d-md-block d-none"
          [translate]="'profile.deliveryAddress.yourDeliveryAddress'"></span>

    <button class="d-sm-block btn btn-primary btn-slim btn-slim-content-text"
            (click)="showDeliveryAddress()">
      <span [translate]="'profile.deliveryAddress.addNewAddress'"></span>
    </button>
  </div>
  <div class="pb-content p-0">
    <table class="pb-table-lg">
      <tbody class="font-sm">
      <tr *ngFor="let item of deliveryAddresses">
        <td class="nowrap">{{item.postNumber}}</td>

        <td>{{item.cityName}}</td>

        <td>{{item.address}}</td>

        <td>
          <span *ngIf="item.isFavourite" [translate]="'common.default'">Default</span>

          <button class="btn btn-text-default" *ngIf="!item.isFavourite"
                  (click)="setFavourite(item.id)"
                  [translate]="'profile.deliveryAddress.makeDefault'">Make Default
          </button>
        </td>

        <td>
          <button class="btn btn-text-primary"
                  (click)="showDeliveryAddress(item)"
                  [translate]="'common.change'">Change
          </button>
        </td>

        <td>
          <i class="icon-trash cursor-pointer font-lg"
             (click)="deleteDeliveryAddress(item)"></i>
        </td>
      </tr>
      </tbody>
    </table>

    <table class="pb-table-xs font-sm mt-xs-max-4">
      <tbody class="font-sm" *ngFor="let item of deliveryAddresses; let i=index">
      <tr>
        <td class="pl-sm-max-0">{{item.postNumber}}</td>

        <td>{{item.cityName}}</td>

        <td class="text-end pr-sm-max-0">
          <button class="btn btn-text-primary"
                  [translate]="'common.change'"
                  (click)="showDeliveryAddress(item)">Change
          </button>
        </td>
      </tr>

      <tr>
        <td class="pl-sm-max-0" colspan="3">{{item.address}}</td>
      </tr>

      <tr>
        <td class="pl-sm-max-0" colspan="2">
          <span *ngIf="item.isFavourite" [translate]="'common.default'">Default</span>

          <button class="btn btn-text-default"
                  *ngIf="!item.isFavourite"
                  [translate]="'profile.deliveryAddress.makeDefault'"
                  (click)="setFavourite(item.id)">Make Default
          </button>
        </td>

        <td class="text-end pr-sm-max-0">
          <i class="icon-trash cursor-pointer font-lg"
             (click)="deleteDeliveryAddress(item)"></i>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="loaded && deliveryAddresses?.length === 0"
       class="pb-content text-center p-3"
       [translate]="'profile.deliveryAddress.noDeliveryYet'">
    No delivery address yet...
  </div>
</div>
